import { render, staticRenderFns } from "./No-activity.vue?vue&type=template&id=0cde623c&"
import script from "./No-activity.vue?vue&type=script&lang=js&"
export * from "./No-activity.vue?vue&type=script&lang=js&"
import style0 from "./No-activity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports